import { EMAIL_VERIFICATION_DELAY, EMAIL_LOCAL_STORAGE_ID } from 'constants/index';

export const startEmailTimer = () => {
  const data = { endTime: Date.now() + EMAIL_VERIFICATION_DELAY };
  localStorage.setItem(EMAIL_LOCAL_STORAGE_ID, JSON.stringify(data));
};
